import _ from 'lodash'
import { useStore } from '@/store'
/**
 * 表单、info 布局结构
 * @param  {[type]} list 配置列表
 * @return {[type]}      结构化后数据
 */
export function gridFormat(list) {
  const gridFormat = []
  let linePointer = 0
  let tempGrid = []
  list.forEach(config => {
    if (_.get(config, 'grid') !== linePointer) {
      linePointer = config.grid
      if (tempGrid.length) {
        gridFormat.push(tempGrid)
        tempGrid = []
      }
    }
    tempGrid.push(config)
  })
  gridFormat.push(tempGrid)
  return gridFormat
}

export function filterCity(list = []) {
  return list.map(({ cityName: label, cityName: value }) => {
    return {
      label,
      value,
      // 是否为终止节点
      leaf: true,
    }
  })
}
/**
 * 深层递归产品所属模块
 * @params (array, string, array)
 * @returns []
 */
let res = []
export function filterCurModule(modules) {
  res = []
  const store = useStore()
  findKeyMap(modules, store.app.moduleInfo.key, [])
  console.log('---产品模块路径---', modules, store.app.moduleInfo.key, res)
  return res
}
function findKeyMap(arr, key, list) {
  if (Array.isArray(arr)) {
    for (const cur of arr) {
      list.push(cur.value)
      if (compare(cur, key, list)) {
        return true
      }
      if (cur.children && findKeyMap(cur.children, key, list)) {
        return true
      }
      list.pop()
    }
  }
}
function compare(cur, key, list) {
  if (cur.nodeKey && key?.includes(cur.nodeKey)) {
    res = [...list]
    return res
  }
}
